import Api from './Api'

class CultureTableService {
    getCulture = () => {
        return Api().get('culture')
    }
    put = data => {
        return Api().put('culture', {
            id: data.id,
            code: data.code,
            en_culture: data.locale.en_culture,
            et_culture: data.locale.et_culture,
            fi_culture: data.locale.fi_culture,
            lt_culture: data.locale.lt_culture,
            la_culture: data.locale.la_culture,
            growth_phase_id: data.growth_phase_id,
            culture_type: data.culture_type,
            level_0_growth_phase: data.level_0_growth_phase,
        })
    }
    createCulture = newCulture => {
        return Api().post('culture', newCulture)
    }
    delete = id => {
        return Api().delete(`culture`, {
            params: { id },
        })
    }
    downloadCulturesCSV() {
        return Api().get(`/cultures/download`)
    }
}

export default new CultureTableService()
